import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11.414,
	height: 11.414,
	viewBox: "0 0 11.414 11.414",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Fermer",
		transform: "translate(0.707 0.707)",
		children: [/* @__PURE__ */ _jsx("line", {
			id: "Line_24",
			"data-name": "Line 24",
			x2: 10,
			y2: 10,
			fill: "none",
			stroke: "#000",
			strokeLinecap: "round",
			strokeWidth: 1
		}), /* @__PURE__ */ _jsx("line", {
			id: "Line_26",
			"data-name": "Line 26",
			x1: 10,
			y2: 10,
			fill: "none",
			stroke: "#000",
			strokeLinecap: "round",
			strokeWidth: 1
		})]
	})]
});
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
